<div class="modal">
  <div class="modal-overlay" (click)="close($event)"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-body m-3">
        <div class="text-center fw-bold fs-2" i18n="@@DialogAgeConfirmText">Are you of legal age to purchase or consume
          alcohol?</div>
        <div class="d-flex">
          <button type="button" class="btn btn-pretty btn-secondary w-50 mx-1" data-bs-dismiss="modal"
            i18n="@@DialogAgeConfirmYesButton" (click)="yes($event)">Yes</button>
          <button type="button" class="btn btn-pretty btn-secondary w-50 mx-1" data-bs-dismiss="modal"
            i18n="@@DialogAgeConfirmNoButton" (click)="no($event)">No</button>
        </div>
        <div class="text-center fs-6" i18n="@@DialogAgeConfirmFooter">Alcohol abuse is dangerous for health.</div>
      </div>

    </div>
  </div>

</div>